import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const LEARNING_PLAN_GOAL_SERVICE_TOKEN = new InjectionToken('LearningPlanGoalService');

export interface LearningPlanGoalServiceInterface {
  getLearningPlanGoals(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?; amount? },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: object[]; count: number }>;
}
